module.exports = "/_next/static/resources/photo-ariel-abcef0d21b6934d16ec9d537d76c064b.jpg";